import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postUpdateVisible = (params) => {
    return axios.post(`${backendHost}/api/admin/jackpot/visible/update`, params);
};

export {
    postUpdateVisible
}